export const PermissionCodes = {
  accessControlUsersAccess: 'access-control.users.access',
  accessControlUsersRead: 'access-control.users.read',
  accessControlUsersWrite: 'access-control.users.write',
  accessControlRolesAccess: 'access-control.roles.access',
  accessControlRolesRead: 'access-control.roles.read',
  accessControlRolesWrite: 'access-control.roles.write',
  accessControlModulesAccess: 'access-control.modules.access',
  salesCampaignTagsAccess: 'sales.campaign-tags.access',
  salesCampaignTagsRead: 'sales.campaign-tags.read',
  salesCampaignTagsWrite: 'sales.campaign-tags.write',
  salesProspectsAccess: 'sales.prospects.access',
  salesProspectsRead: 'sales.prospects.read',
  salesProspectsWrite: 'sales.prospects.write',
} as const;

export type PermissionCode = (typeof PermissionCodes)[keyof typeof PermissionCodes];

export function moduleAccessCode(moduleCode: string): string {
  return `${moduleCode}.access`;
}

export function moduleReadCode(moduleCode: string): string {
  return `${moduleCode}.read`;
}

export function moduleWriteCode(moduleCode: string): string {
  return `${moduleCode}.write`;
}

export function moduleDeleteCode(moduleCode: string): string {
  return `${moduleCode}.delete`;
}
